import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { RoutingModule } from './routing.module';
import { AppComponent } from './app.component';
import { FooterComponent } from './footer.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { IconComponent } from './icon.component'; // Standalone component
import { MatIconModule } from '@angular/material/icon';
import { HttpClientModule } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ContactComponent } from './contact.component';
import { NotFoundComponent } from './not-found.component';
import { MainComponent } from './main.component';
// AboutComponent is now standalone and imported in routing
import { EmployersComponent } from './employers.component';
import { VacanciesComponent } from './vacancies.component';
import { SharedService } from './shared.service';
import { ViewJobComponent } from './view-job.component';
import { MatRippleModule } from '@angular/material/core';
import { PrivacyComponent } from './privacy.component';
import { DirectApplyComponent } from './direct-apply.component';
import { ApplyComponent } from './apply.component';
import { customPaginator } from './providers/custompaginator';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { SocketIoService } from './socketio.service';
import { environment } from 'client/environments/environment';
import { LogsComponent } from './logs/logs.component';
import { DatePipe } from '@angular/common';
import { LayoutModule } from '@angular/cdk/layout';
// Removed ngx-google-analytics - using direct gtag integration instead
import { AppliedComponent } from './components/applied.component';
// import { Router } from '@angular/router';
import { UppercaseDirective } from './directives/to-uppercase.directive';
import { SearchBoxComponent } from './components/search-box.component';
import { BreadcrumbsComponent } from './components/breadcrumbs.component';
import { ApplePaginatorComponent } from './components/apple-paginator.component';
import { AppleMultiselectComponent } from './components/apple-multiselect.component';
import { MatButtonModule } from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';
import { MatSliderModule } from '@angular/material/slider';
import {MatSelectModule} from '@angular/material/select';
import {MatPaginatorModule} from '@angular/material/paginator'
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import {MatListModule} from '@angular/material/list';
import {MatCheckboxModule} from '@angular/material/checkbox';
import {MatAutocompleteModule} from '@angular/material/autocomplete';
import {MatSnackBarModule} from '@angular/material/snack-bar';
import { MatPaginatorIntl } from "@angular/material/paginator"
import { BlogListComponent } from './blog/blog-list.component';
import { BlogDetailComponent } from './blog/blog-detail.component';
import { BlogCardComponent } from './blog/blog-card.component';
import { BlogCardSkeletonComponent } from './blog/blog-card-skeleton.component';
import { BlogBlockHeadingComponent } from './blog/blocks/block-heading.component';
import { BlogBlockParagraphComponent } from './blog/blocks/block-paragraph.component';
import { BlogBlockImageComponent } from './blog/blocks/block-image.component';
import { BlogBlockLinkComponent } from './blog/blocks/block-link.component';
import { BlogBlockButtonComponent } from './blog/blocks/block-button.component';
import { BlogBlockQuoteComponent } from './blog/blocks/block-quote.component';
import { TeamProfileComponent } from './team-profile.component';
import { AuthorPageComponent } from './author/author-page.component';
import { SocialLinksComponent } from './components/social-links.component';
import { ErrorStateComponent } from './components/error-state.component';
import { TeamProfileSkeletonComponent } from './team-profile-skeleton.component';
import { PublicShadcnToasterComponent } from './components/public-shadcn-toaster.component';
import { ToastService } from './admin/services/toast.service';
import { FeaturedJobsListComponent } from './shared/featured-jobs-list/featured-jobs-list.component';
import { FaqBlockComponent } from './shared/faq-block/faq-block.component';
import { CtaBlockComponent } from './shared/cta-block/cta-block.component';
import { SeoPageComponent } from './seo-page/seo-page.component';
import { SeoPageSlugCacheService } from './services/seo-page-slug-cache.service';
import { APP_INITIALIZER } from '@angular/core';
// CareersComponent is now standalone and imported in routing

@NgModule({
  declarations: [
    AppComponent,
    MainComponent,
    FooterComponent,
    // IconComponent is standalone, imported below
    ContactComponent,
    // AboutComponent is now standalone
    EmployersComponent,
    VacanciesComponent,
    ViewJobComponent,
    DirectApplyComponent,
    ApplyComponent,
    AppliedComponent,
    PrivacyComponent,
    NotFoundComponent,
    LogsComponent,
    UppercaseDirective,
    SearchBoxComponent,
    ApplePaginatorComponent,
    AppleMultiselectComponent,
    BlogListComponent,
    BlogDetailComponent,
    BlogCardComponent,
    BlogCardSkeletonComponent,
    AuthorPageComponent,
    BlogBlockHeadingComponent,
    BlogBlockParagraphComponent,
    BlogBlockImageComponent,
    BlogBlockLinkComponent,
    BlogBlockButtonComponent,
    BlogBlockQuoteComponent,
    TeamProfileComponent,
    ErrorStateComponent,
    TeamProfileSkeletonComponent,
    PublicShadcnToasterComponent,
    SeoPageComponent,
    // CareersComponent removed - now standalone
    // SocialLinksComponent is now standalone
  ],
  imports: [
    BrowserModule,
    RoutingModule,
    BrowserAnimationsModule,
    IconComponent, // Standalone component imported here
    SocialLinksComponent, // Standalone component imported here
    MatSliderModule,
    MatIconModule,
    HttpClientModule,
    MatButtonModule,
    MatInputModule,
    FormsModule,
    MatSelectModule,
    ReactiveFormsModule,
    MatPaginatorModule,
    MatProgressSpinnerModule,
    MatListModule,
    MatRippleModule,
    MatCheckboxModule,
    MatAutocompleteModule,
    MatButtonToggleModule,
    MatSnackBarModule,
    LayoutModule,
    BreadcrumbsComponent,
    FeaturedJobsListComponent,
    FaqBlockComponent,
    CtaBlockComponent,
  ],
  providers: [
    SharedService,
    SocketIoService,
    DatePipe,
    ToastService,
    { provide: MatPaginatorIntl, useValue: customPaginator() },
    {
      provide: APP_INITIALIZER,
      multi: true,
      deps: [SeoPageSlugCacheService],
      useFactory:
        (cache: SeoPageSlugCacheService) => () => cache.initialize(),
    },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
